// GÉNÉRÉ par `pnpm blueprint apply` à partir de blueprint.json — ne pas modifier à la main.
import type { WebModule } from "../core/modules";
import crm from "./crm/index";
import guides from "./guides/index";
import xAtelier from "./x-atelier/index";
import xGaranties from "./x-garanties/index";
import xMessagerie from "./x-messagerie/index";
import xAppels from "./x-appels/index";
import xSite from "./x-site/index";
import xUrable from "./x-urable/index";
import xAssistant from "./x-assistant/index";

export const MODULES: WebModule[] = [crm, guides, xAtelier, xGaranties, xMessagerie, xAppels, xSite, xUrable, xAssistant];
